import AccountApi from './accountApi';

const accountApi = new AccountApi();

export { accountApi };
